import functions from './functions';
import {InputGuests} from './components/input-guests';

$(() => {

    $('.input-guests').each((i, elem) => {
        elem._inputGuests = new InputGuests(elem);
    });
    
    $(document).on('click', '[data-scroll-to]', e => {
        e.preventDefault();
        const $this = $(e.target);
        let scrollTo = $this.attr('data-scroll-to').split(',');
        functions.scrollToElement(scrollTo[0], scrollTo[1] || 0);
    });

    $(document).on('click', '[data-toggle-summary]', e => {
        e.preventDefault();
        const $button = $(e.currentTarget);
        const $summary = $button.prev('.activity-summary');
        const expanded = $summary.toggleClass('expanded').hasClass('expanded');
        $button.text(expanded ? 'Sakrij' : 'Pročitaj više');
    });

    // Photos on this site are of children - not real download prevention
    // (anyone can still pull them from devtools/network tab), just raises
    // the bar past casual right-click-save/drag-save. Blocked sitewide
    // (not just on img) per explicit request.
    $(document).on('contextmenu', e => {
        e.preventDefault();
    });
    $(document).on('dragstart', 'img', e => {
        e.preventDefault();
    });

    // iOS Safari (13+) ignores -webkit-touch-callout:none specifically on
    // real <img> elements (WebKit won't let a site block its long-press
    // menu on the image itself) - it still works on plain elements, so an
    // invisible div on top of the image intercepts the long-press instead.
    // Inserted as a sibling (never wraps the img) - these selectors are all
    // real content photos that already sit inside a position:relative,
    // definitely-sized parent (the img{position:absolute;inset:0} pattern -
    // see context.md's recurring-bugs list), so the overlay can reuse that
    // same positioning context instead of needing its own. Deliberately not
    // a blind `img` selector - logos/icons/gutenberg-editor images don't
    // have that positioned ancestor and would render broken.
    $('.theme-card__image, .card-locality__image, .card-travel__image, .block-banner__media, #hero-gallery img, .theme-timeline-item__media img, .entry-content img, .wp-block-image img')
        .not('.img-touch-guarded')
        .each((i, img) => {
            $(img)
                .addClass('img-touch-guarded')
                .after('<span class="img-touch-guard" style="position:absolute;inset:0;-webkit-touch-callout:none;"></span>');
        });

    // The guard span sits on top of the img, so a normal tap would
    // otherwise get eaten before it reaches the card link/lightGallery
    // trigger underneath - forward it via the real DOM .click() (fires
    // actual navigation/bound listeners, unlike jQuery's synthetic
    // .trigger('click')) to whichever actionable element wraps the image.
    $(document).on('click', '.img-touch-guard', function () {
        const $img = $(this).prev('img.img-touch-guarded');
        const target = $img.closest('a[href], [data-gallery-id], [data-index]')[0] || $img[0];
        target.click();
    });
})